import { UserPermissions } from '@centecomm/portal-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import InsuraceNavigationIcon from 'Icons/NavigationItem/Insurance';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PropertyOccupantSelectionModal from 'Shared/PropertyOccupantSelection/PropertyOccupantSelectionModal';
import useComplianceHubEnabled from 'utils/Hooks/LaunchDarkly/useComplianceHubEnabled';

import QuickActionButton from './QuickActionButton';

function COIQuickActionModal(): JSX.Element | null {
    const { t } = useTranslation(['dashboardFeature']);
    const history = useHistory();
    const { isTenant } = useCurrentUser();
    const complianceHubEnabled = useComplianceHubEnabled();

    const [show, setShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [property, setProperty] = useState<number | null>(null);
    const [occupant, setOccupant] = useState<number | null>(null);
    const [hasNoProperties, setHasNoProperties] = useState<boolean>(false);

    const routeToCOI = () => {
        history.push(
            isTenant
                ? `/business/${occupant}/insurance`
                : complianceHubEnabled
                ? `/compliance-hub/${property}/occupants/${occupant}/insurance`
                : `/locations/${property}/occupants/${occupant}`,
        );
    };

    const hasNoOccupants = useMemo(() => {
        if (isTenant) {
            return t('dashboardFeature:modals.submitCOI.errors.noBusinesses');
        }
        return t('dashboardFeature:modals.submitCOI.errors.noOccupants');
    }, [isTenant, t]);

    useEffect(() => {
        if (show && occupant && property) routeToCOI();
    }, [property, occupant, show]);

    if (hasNoProperties) return null;

    return (
        <>
            {!loading && (
                <QuickActionButton
                    Icon={InsuraceNavigationIcon}
                    setShow={setShow}
                    buttonText={t('dashboardFeature:links.submitCOI.title')}
                    strokeWidth="1px"
                />
            )}
            <PropertyOccupantSelectionModal
                show={show}
                setShow={setShow}
                modalHeader={t('dashboardFeature:modals.submitCOI.header')}
                noOccupantsPlaceholder={hasNoOccupants}
                occupantsPlaceholder={isTenant ? t('dashboardFeature:modals.submitCOI.placeholder') : ''}
                userPermission={UserPermissions.AddCertificateOfInsurance}
                propertyId={property}
                occupantId={occupant}
                setPropertyId={setProperty}
                setOccupantId={setOccupant}
                setLoading={setLoading}
                setHasNoProperties={setHasNoProperties}
            />
        </>
    );
}

export default COIQuickActionModal;
